import { AlarmClock } from "lucide-react";
import { lateLabel } from "./production-order-utils";

// Aviso NÃO-BLOQUEANTE de "nasce atrasada": o fim planejado já ultrapassa o
// prazo do cliente. É informação de negócio legítima (o cliente pediu para antes do que a linha
// consegue entregar), então NUNCA impede salvar — só mostra o tamanho do buraco antes do gestor
// confirmar. Espelha o OpExpedienteNotice (mesma família de avisos deste formulário).
export function DueDateNotice({ due, end }: { due?: string | null; end?: string }) {
  if (!due || !end) return null;
  const lateMin = Math.ceil((new Date(end).getTime() - new Date(due).getTime()) / 60_000);
  if (!Number.isFinite(lateMin) || lateMin <= 0) return null;
  return (
    <p
      role="status"
      className="flex items-center gap-1.5 text-[11px] text-rd-warning-700"
      data-testid="po-due-late-notice"
    >
      <AlarmClock className="h-3 w-3 shrink-0" />
      Esta ordem já nasce atrasada: o fim planejado passa {lateLabel(lateMin).replace("+", "")} do
      prazo. O agendamento é permitido.
    </p>
  );
}
